export default __webpack_public_path__ + "static/media/107.d700cd3f.jpeg";